module.exports = __webpack_public_path__ + "static/media/default_photo.60fb17df.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/default_photo.png
// module id = 754
// module chunks = 1